import { Link } from '@datacamp/waffles/link';
import { Paragraph } from '@datacamp/waffles/paragraph';
import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { I18N_PLACEHOLDER } from '../i18n';
import { useDispatch } from '../interfaces/State';
import * as actions from '../redux/actions';
import ReportModal from '../shared-components/ReportModal';

type Props = {
  onExit: () => void;
  submitRequestState: unknown;
};

const FeedbackReporter: React.FC<Props> = ({ onExit, submitRequestState }) => {
  const dispatch = useDispatch();
  const onCancel = useCallback(() => {
    dispatch(actions.epicSubmitFeedback({ rating: 1 }));
    onExit();
  }, [dispatch, onExit]);
  const onSubmit = useCallback(
    ({ userFeedback }: any) => {
      dispatch(actions.epicSubmitFeedback({ userFeedback, rating: 1 }));
    },
    [dispatch],
  );
  const { t } = useTranslation();

  return (
    <ReportModal
      successMessage={
        <Paragraph>
          <Trans
            t={t}
            i18nKey="FeedbackReporter.successMessage"
            components={{
              'submit-link': (
                <Link
                  href="https://support.datacamp.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {I18N_PLACEHOLDER}
                </Link>
              ),
            }}
          />
        </Paragraph>
      }
      optional={false}
      modalTitle={t('FeedbackReporter.title')}
      submitRequestState={submitRequestState}
      onExit={onExit}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
};

export default FeedbackReporter;
